<template>
  <v-dialog v-model="show" max-width="850px" persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-card :rounded="$vuetify.breakpoint.xsOnly ? '0' : 'xl'" class="pa-0 pa-sm-4 d-flex flex-column relative-card">
      <v-btn icon color="grey darken-1" class="close-btn-top" @click="fecharModal" :disabled="loading">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-card-title class="headline primary--text justify-center pt-4 pb-0 font-weight-bold secondary-font">
        Prévia do Recibo de Entrega de EPI
      </v-card-title>

      <v-card-text class="pt-4 px-2 px-sm-6">
        <p class="body-2 text-center mb-6 grey--text text--darken-1">
          Confira os dados do documento que será gerado e assinado eletronicamente.
        </p>

        <v-sheet outlined class="pa-3 pa-sm-6 rounded-lg white border-sheet" elevation="1">
          <div class="text-center mb-6 border-bottom pb-4">
            <h3 class="text-uppercase font-weight-black primary--text mb-1">Comprovante de Fornecimento de EPI</h3>
            <span class="caption grey--text">AMI - Atendimento Médico Integrado | NR-06 Compliance</span>
          </div>

          <div class="mb-6">
            <div class="section-title primary--text mb-2">I. Dados do Colaborador</div>
            <v-row dense class="body-2">
              <v-col cols="12" sm="6"><strong>Nome Completo:</strong> {{ dadosColaborador.nome }}</v-col>
              <v-col cols="12" sm="6"><strong>CPF:</strong> {{ dadosColaborador.cpf }}</v-col>
              <v-col cols="12" sm="6"><strong>Empresa:</strong> {{ dadosColaborador.empresa }}</v-col>
              <v-col cols="12" sm="6"><strong>Unidade/Workspace:</strong> {{ dadosColaborador.unidade }}</v-col>
              <v-col cols="12" sm="6"><strong>Setor:</strong> {{ dadosColaborador.setor }}</v-col>
              <v-col cols="12" sm="6"><strong>Função:</strong> {{ dadosColaborador.funcao }}</v-col>
              <v-col cols="12" sm="6"><strong>Matrícula:</strong> {{ dadosColaborador.matricula }}</v-col>
            </v-row>
          </div>

          <v-divider class="mb-4"></v-divider>

          <div class="mb-4">
            <div class="section-title primary--text mb-2">II. Detalhes dos EPIs Solicitados</div>

            <div class="table-responsive">
              <v-simple-table dense class="border-table table-min-width">
                <template v-slot:default>
                  <thead>
                    <tr class="grey lighten-4">
                      <th class="text-left font-weight-bold text-uppercase caption">EPI / Descrição</th>
                      <th class="text-center font-weight-bold text-uppercase caption">CA</th>
                      <th class="text-center font-weight-bold text-uppercase caption">Lote</th>
                      <th class="text-center font-weight-bold text-uppercase caption">Qtd</th>
                      <th class="text-center font-weight-bold text-uppercase caption">Data Entrega</th>
                      <th class="text-center font-weight-bold text-uppercase caption">Vencimento</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in epis" :key="item.id">
                      <td class="py-2">
                        <div class="font-weight-bold primary--text">{{ item.epiNome || 'EPI não identificado' }}</div>
                      </td>
                      <td class="text-center">{{ item.ca || '-' }}</td>
                      <td class="text-center">{{ item.lote || '-' }}</td>
                      <td class="text-center font-weight-bold">{{ item.quantidade || 1 }}</td>
                      <td class="text-center">{{ item.dataEntrega || '-' }}</td>
                      <td class="text-center">{{ item.dataVencimento || '-' }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>

              <v-row dense class="mt-3 caption grey--text text--darken-1">
                <v-col cols="12" sm="6"
                  ><strong>Responsável pela Entrega:</strong> {{ dadosEntregaGenericos.responsavel }}</v-col
                >
                <v-col cols="12" sm="6" class="text-sm-right"
                  ><strong>Notificação Enviada em:</strong> {{ dadosEntregaGenericos.dataNotificacao }}</v-col
                >
              </v-row>
            </div>
          </div>

          <div class="mb-6 px-4 py-3 termo-box">
            <p class="font-weight-bold mb-1 caption grey--text text--darken-4">Termo de Responsabilidade</p>
            <p class="caption text-justify mb-2 grey--text text--darken-3">
              Declaro ter recebido da empresa o(s) Equipamento(s) de Proteção Individual (EPI) listado(s) acima,
              gratuitamente e em perfeitas condições de uso. Comprometo-me a cumprir as disposições da NR-06:
            </p>
            <ul class="caption grey--text text--darken-3 pl-4 mb-0" style="line-height: 1.4;">
              <li>Utilizar o EPI apenas para a finalidade a que se destina;</li>
              <li>Responsabilizar-me pela guarda e conservação;</li>
              <li>Comunicar à empresa qualquer alteração que o torne impróprio para uso;</li>
              <li>Devolver o equipamento quando da minha rescisão contratual ou quando solicitado.</li>
            </ul>
          </div>

          <v-divider class="mb-4"></v-divider>

          <div>
            <div class="section-title primary--text text-center mb-4">III. Formalização e Assinatura Eletrônica</div>

            <div class="d-flex flex-column align-center justify-center">
              <template v-if="!assinaturaAtual">
                <p class="caption error--text mb-4 font-weight-bold text-center">
                  Nenhuma assinatura eletrônica detectada para o seu usuário. Desenhe uma abaixo para prosseguir:
                </p>
                <div class="w-100 px-4">
                  <SelectAssinatura @assinatura-saved="onNovaAssinaturaSalva" />
                </div>
              </template>

              <template v-else>
                <v-card
                  outlined
                  class="pa-2 bg-signature text-center d-flex flex-column align-center justify-center"
                  max-width="320px"
                  rounded="lg"
                >
                  <img :src="assinaturaAtual" class="img-assinatura-previa mb-2" alt="Assinatura" />
                  <v-divider class="w-100 my-1"></v-divider>
                  <div class="signature-meta">
                    <div>Assinado eletronicamente via plataforma AMI</div>
                    <div class="font-weight-bold mt-0.5">Data/Hora: {{ dataHoraAtual }}</div>
                  </div>
                </v-card>
              </template>
            </div>
          </div>
        </v-sheet>
      </v-card-text>

      <v-card-actions
        class="pa-4 d-flex flex-column-reverse flex-sm-row justify-center align-center w-100"
        style="background-color: white; border-top: 1px solid #eee;"
      >
        <v-btn
          color="grey darken-1"
          text
          class="secondary-font font-weight-bold px-6 mt-3 mt-sm-0 w-100-mobile"
          @click="fecharModal"
          :disabled="loading"
        >
          Fechar Prévia
        </v-btn>

        <v-btn
          v-if="assinaturaAtual"
          color="primary"
          class="secondary-font text-capitalize font-weight-bold px-4 px-sm-8 py-5 w-100-mobile"
          rounded
          elevation="4"
          :loading="loading"
          @click="confirmar"
        >
          <v-icon left size="18">mdi-file-sign</v-icon>
          Confirmar e Assinar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SelectAssinatura from '@/modules/Assinatura/SelectAssinatura'

export default {
  name: 'EntregaConfirmacaoEpi',
  components: {
    SelectAssinatura
  },
  props: {
    value: { type: Boolean, default: false },
    epis: { type: Array, required: true },
    assinaturaAtual: { type: String, default: null },
    loading: { type: Boolean, default: false }
  },
  data() {
    return {
      dataHoraAtual: new Date().toLocaleString('pt-BR')
    }
  },
  computed: {
    show: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    dadosColaborador() {
      if (!this.epis || !this.epis.length) return {}
      const primeiroItem = this.epis[0]

      return {
        nome: primeiroItem.funcionarioNome || 'Não identificado',
        cpf: primeiroItem.funcionarioCpf || 'Não informado',
        empresa: primeiroItem.empresaNome || 'Empresa não identificada',
        unidade: 'Unidade Matriz',
        setor: primeiroItem.setorNome || 'Não informado',
        funcao: primeiroItem.funcaoNome || 'Não informada',
        matricula: primeiroItem.matricula || 'Não informada'
      }
    },
    dadosEntregaGenericos() {
      if (!this.epis || !this.epis.length) return {}
      const primeiroItem = this.epis[0]
      return {
        responsavel: primeiroItem.responsavelEntrega || 'Almoxarifado Central',
        dataNotificacao: new Date().toLocaleDateString('pt-BR')
      }
    }
  },
  methods: {
    fecharModal() {
      this.show = false
    },
    onNovaAssinaturaSalva() {
      this.$emit('nova-assinatura')
    },
    confirmar() {
      this.$emit('confirmar')
    },
    formatarData(dataString) {
      if (!dataString) return new Date().toLocaleDateString('pt-BR')
      try {
        return new Date(dataString).toLocaleDateString('pt-BR')
      } catch (e) {
        return dataString
      }
    }
  }
}
</script>

<style scoped>
.relative-card {
  position: relative;
}
.close-btn-top {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
}
.border-sheet {
  border: 1px solid #dcdcdc !important;
  background-color: #fafafa !important;
}
.border-bottom {
  border-bottom: 2px dashed #e0e0e0;
}
.border-table {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
}
.termo-box {
  background-color: #f7f7f7;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}
.bg-signature {
  background-color: #fff !important;
  border: 1px solid #b0bec5 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05) !important;
}
.signature-meta {
  font-size: 10px;
  color: #546e7a;
  line-height: 1.2;
}
.w-100 {
  width: 100%;
}
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-min-width {
  min-width: 600px;
}

@media (max-width: 600px) {
  .w-100-mobile {
    width: 100% !important;
  }
}
.img-assinatura-previa {
  mix-blend-mode: multiply;
  object-fit: contain;
  max-height: 110px;
  max-width: 260px;
  width: 100%;
  display: block;
  margin: 0 auto;
  padding-bottom: 5px;
}
</style>
